import { OnInit, Component, Input, HostListener, ChangeDetectorRef } from '@angular/core';
import { UserService } from '@app/services/user/user.service';
import { INTERNATIONAL_TAG_NAME } from '@utils/order.utils';
import { FulfillService } from '../../fulfill.service';
import { PrintDocumentType, buildPrintOptions, extractPrintSectionsAndOptions } from '@utils/print-utils';
import { PrintService } from '@app/services/print/print.service';

import { Router } from '@angular/router';
import { PanelState } from '../../utils/models';
import { AdjacentRowDirection, getAdjacentRow } from '@utils/table.utils';
import { ApiService } from '@app/core/services/api/api.service';
const PrintActions = [
  PrintDocumentType.LABELS,
  PrintDocumentType.PACKING_SLIPS,
  PrintDocumentType.BROCHURE,
  PrintDocumentType.COMMERCIAL_INVOICE,
  PrintDocumentType.PACK_AND_SHIP,
  PrintDocumentType.GREETING_CARD,
  PrintDocumentType.CARD_ISLE,
];

@Component({
  selector: 'fulfill-side-panel-order',
  templateUrl: './fulfill-side-panel-order.component.html',
  styleUrls: ['./fulfill-side-panel-order.component.scss'],
  standalone: false,
})
export class FulfillSidePanelOrderComponent implements OnInit {
  @Input() order;
  isShown = false;
  isPickAndPackFocus;
  printOptions = [];
  printSections = [];
  constructor(
    private userService: UserService,
    public fulfillService: FulfillService,
    private printService: PrintService,
    private router: Router,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // this.initHotkeysListener();
    this.isShown = true;
    const currentUserRole: any = this.userService.currentMeUser?.roles;
    this.isPickAndPackFocus = currentUserRole.includes('PICKNPACK_FOCUS');
    const isInternational = this.isInternationalOrder();
    buildPrintOptions(
      this.fulfillService.shopMetadata,
      PrintActions,
      'order',
      {
        supportsInternationalShipping: isInternational,
      },
      this.apiService,
      () => this.fulfillService.getCardIsleDevicesCached(),
    ).then((options) => {
      const formatPrintOptions = extractPrintSectionsAndOptions(options);
      this.printOptions = formatPrintOptions.printOptions;
      this.printSections = formatPrintOptions.printSections;
      this.cdr.detectChanges();
    });
  }

  isInternationalOrder() {
    return this.order?.orderTags?.some?.((val) => val.name === INTERNATIONAL_TAG_NAME) ?? false;
  }

  @HostListener('document:keydown.ArrowRight', ['$event'])
  @HostListener('document:keydown.ArrowLeft', ['$event'])
  handleOrderSwitchByKey(event: KeyboardEvent): void {
    // Check for your desired key combination
    event.preventDefault();

    const currentOrder = this.fulfillService.activeOrder;
    if (currentOrder) {
      const batchOrders =
        this.fulfillService.activeTab === 'added'
          ? this.fulfillService.activeBatch.addedOrders
          : this.fulfillService.activeBatch.orders;
      const indexDelta = event.key.toLowerCase().includes('left') ? -1 : 1;
      const switchToOrder = getAdjacentRow(currentOrder, batchOrders, indexDelta);
      if (switchToOrder) {
        const newPrevOrder = currentOrder;
        const newNextOrder = getAdjacentRow(switchToOrder, batchOrders, AdjacentRowDirection.NEXT);
        [newPrevOrder, newNextOrder].filter(Boolean).forEach((order) => {
          this.fulfillService.preloadOrderForBrowsing(order.id);
        });
        this.handleOrderSwitch(switchToOrder);
      }
    }
  }

  private async handleOrderSwitch(switchToOrder) {
    try {
      this.fulfillService.setPanelState(PanelState.ORDER);
      const expandedOrder = await this.fulfillService.getOrder(switchToOrder.id);
      this.fulfillService.setActiveOrder(expandedOrder);
    } catch (e) {
      this.fulfillService.setPanelState(PanelState.BATCH);
    }
  }

  onPrintTriggerFulfillment(orderId: string) {
    const shopMetadata = this.fulfillService.shopMetadata;
    if (shopMetadata?.onPrintTriggerFulfillment) {
      this.fulfillService.onPrintTriggerFulfillment.next(orderId);
    }
  }

  printOrder(event) {
    const action = event.action;
    this.onPrintTriggerFulfillment(this.order.id);
    this.printService.printOrder(action, [this.order.id]);
  }
}
